import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type PromoCodeTransactionFragment = { id: string, email: string, amount: any, transactionStatus: string, token: string, date: any, balanceData: any };

export const PromoCodeTransactionFragmentDoc = gql`
    fragment PromoCodeTransactionFragment on PromoCodeTransactionType {
  id
  email
  amount
  transactionStatus
  token
  date
  balanceData
}
    `;